// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3msz9","productName":"Table_productName__3Q-pR"};